import React from "react";
import { Dialog, Pane, Text, Strong } from "evergreen-ui";
import { IMAGE_PATH } from "../../Utils/variables";

import CustomButton from "./CustomButton";

const CustomDeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Confirmation",
  message = "Are you sure you want to delete this item?",
  itemName = "",
  isDeleting = false,
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
}) => {
  return (
    <Dialog
      isShown={isOpen}
      hasHeader={false}
      hasFooter={false}
      hasClose={false}
      onCloseComplete={onClose}
      width={500}
      shouldCloseOnOverlayClick={!isDeleting}
      shouldCloseOnEscapePress={!isDeleting}
      containerProps={{
        alignSelf: "center",
      }}
    >
      <Pane
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        padding={10}
        paddingTop={12}
        paddingBottom={16}
        borderBottom="1px solid"
        borderColor="grey"
      >
        <Text size={600} fontWeight={600} color="default">
          {title}
        </Text>
        <button
          style={{ border: "none", background: "transparent" }}
          onClick={onClose}
          disabled={isDeleting}
        >
          <img
            src={IMAGE_PATH + "close.svg"}
            style={{
              color: "#474d66",
              height: "16px",
              width: "16px",
              cursor: "pointer",
            }}
            alt="close"
          />
        </button>
      </Pane>

      <Pane paddingTop={20} paddingBottom={20}>
        <Text size={400} marginBottom={12} display="block">
          {message}
        </Text>

        {itemName && (
          <Pane
            background="#fafafa"
            padding={12}
            borderRadius={4}
            marginBottom={12}
            border="1px solid"
            borderColor="#ecebec"
          >
            <Text size={400}>
              <Strong>Bill No: {itemName}</Strong>
            </Text>
          </Pane>
        )}

        <Text size={300} color="muted">
          This action cannot be undone.
        </Text>
      </Pane>

      <Pane
        display="flex"
        justifyContent="flex-end"
        gap={12}
        paddingTop={20}
        paddingBottom={12}
        borderTop="1px solid"
        borderColor="gray"
      >
        <CustomButton variant="outline" onClick={onClose} disabled={isDeleting}>
          {cancelButtonText}
        </CustomButton>
        <CustomButton disabled={isDeleting} onClick={onConfirm}>
          {isDeleting ? "Deleting..." : confirmButtonText}
        </CustomButton>
      </Pane>
    </Dialog>
  );
};

export default CustomDeleteConfirmationModal;
